import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, List, WhiteSpace, ListView } from 'antd-mobile/lib';
import { createForm } from 'rc-form';
import Util from '../../../util.js';

import { getTransformationHistory, getHistoryFundCodeAndName, getSupperFundHome } from '../../../action/investmentAction';

import { hashHistory } from 'react-router';
import NavigatorMain from '../../NavigatorMain';

function MyBody(props) {
  return (
    <div className="am-list-body my-body">
      <span style={{ display: 'none' }}>you can custom body wrap element</span>
      {props.children}
    </div>
  );
}


let productType = [
  {
    label: '全部类型',
    value: '',
    key:1
  },
  {
    label: '赎回转申购',
    value: 'T822',
    key:2
  },
  {
    label: '申购',
    value: 'T022',
    key:3
  },
  {
    label: '赎回',
    value: 'T024',
    key:4
  },
  {
    label: '设置分红方式',
    value: 'T029',
    key:5
  },
  {
    label: '基金转换',
    value: 'T036',
    key:6
  },
  {
    label: '定期定额申购',
    value: 'T039',
    key:7
  },
  {
    label: '定期定额申购协议',
    value: 'E201',
    key:8
  },
  {
    label: '定期定额申购修改',
    value: 'E202',
    key:9
  },
  {
    label: '定期定额申购取消',
    value: 'E203',
    key:10
  },
  {
    label: '定期定额基金转换协议',
    value: 'E204',
    key:11
  },
  {
    label: '定期定额基金转换修改',
    value: 'E205',
    key:12
  },
  {
    label: '定期定额基金转换取消',
    value: 'E206',
    key:13
  },
  {
    label: '预约赎回协议',
    value: 'E207',
    key:14
  },
  {
    label: '预约赎回取消',
    value: 'E208',
    key:15
  },
  {
    label: '赎回转认购',
    value: 'T220',
    key:26
  },
  {
    label: '定期赎回转申购协议',
    value: 'E224',
    key:16
  },
  {
    label: '定期赎回转申购修改',
    value: 'E225',
    key:17
  },
  {
    label: '定期赎回转申购取消',
    value: 'E226',
    key:18
  },
  {
    label: '活期通认购',
    value: 'T420',
    key:19
  },
  {
    label: '活期通申购',
    value: 'T422',
    key:20
  },
  {
    label: '超级基金调仓',
    value: 'T999',
    key:21
  },
  {
    label: '超级基金银行卡申购',
    value: 'T522',
    key:22
  },
  {
    label: '定期外部赎回转申购协议',
    value: 'E227',
    key:23
  },
  {
    label: '定期外部赎回转申购修改',
    value: 'E228',
    key:24
  },
  {
    label: '定期外部赎回转申购取消',
    value: 'E229',
    key:25
  },
  {
    label: '智投管理费扣除',
    value: 'TC24',
    key:26
  }
]
let ua=navigator.userAgent.toLowerCase()

var objArr;

/*产品交易记录*/
class TransactionRecordProduct extends Component {
  constructor(props) {
    super(props);
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    this.state = {
      isLoading:true,
      dataSource: ds.cloneWithRows([]),
      height:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1?window.winHeight:window.winHeight - 88,
      businessType:"",
      fundCode:"",
      modalFlag:false,
      sValue:[""],
      productType:[""],
      superHome:null,
      allFundList:null,
      HomeFlag:false,
      FundListFlag:false,
      pageIndex:1,
      pageSize:30,
      totalDataArr:[],
    };
  }
  componentDidMount(){
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    let dispatch = this.props.dispatch;
    // const hei = window.winHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
    const hei = window.winHeight - 88;
    // simulate initial Ajax
    // setTimeout(() => {
    //   this.setState({
    //     dataSource: ds.cloneWithRows([]),
    //     //dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
    //     isLoading: false,
    //     height: hei,
    //   });
    // }, 600);
    let data = {
        pageIndex:this.state.pageIndex,
        pageSize:this.state.pageSize,
        businessType:this.state.businessType,
        fundCode:this.state.fundCode,
    }
    dispatch(getTransformationHistory(data,this.callbackData.bind(this),this))
  }
  componentWillMount(){
    objArr = [];

    let { dispatch } = this.props;
    let that = this;
    let data = {
      superFundCode:"",
      pageIndex:1,
      pageSize:99,
    }
    document.getElementsByTagName('title')[0].innerHTML = "交易记录";
    //dispatch(getTransformationHistory(data,this.callbackData.bind(this),that))
    dispatch(getSupperFundHome({},(data)=>{
        console.log(data.singleSuperFundViews,"datadatadata",data)
        //let superHome = data ? ( data.singleSuperFundViews ? data.singleSuperFundViews : []) : null
        this.setState({
          superHome:data,
          HomeFlag:true
        })
    },this));
    dispatch(getHistoryFundCodeAndName({},this,(data)=>{
      this.setState({
        allFundList:data,
        FundListFlag:true
      })
    }));

  }
  callbackData(data){
    let totalDataArr = this.state.totalDataArr.concat(data.records);
    this.state.loadingFlag ? this.setState({loadingFlag:false}) : null;
    if(data.records.length !== 0){
      let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
      if(data.records.length < this.state.pageSize){
        this.setState({
          isLoading:0,
          dataSource: ds.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          pageIndex: this.state.pageIndex+1,
          handleFlag:false,
        })
      }else{
        this.setState({
          isLoading:false,
          pageIndex: this.state.pageIndex+1,
          dataSource: ds.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          handleFlag:false,
        })
      }
    }else{
      this.setState({
        isLoading:0
      })
    }
  }
  goBack(){
    hashHistory.go(-1)
  }
  goTransactionDetail(item){
    let data = {
      businessType:item.businessType,
      tradeRequestId:item.tradeRequestId
    }
    if(item.businessType == "TC24") {
      hashHistory.push({
          pathname:'/Servicechargerecord',
          state:{
            businessType:item.businessType,
            tradeRequestId:item.tradeRequestId
          }
      })
    }else {
      hashHistory.push({
          pathname:'/TransactionDetail',
          state:{
            data
          }
      })
    }
  }
  productTypeCallback(e){
    let fundCode = e[0];
    let _this = this;
    let { dispatch } = this.props;
    let flag;
    if(this.state.totalDataArr.length !== 0){
      flag = true;
    }else{
      flag = false;
    }
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    this.setState({
      productAll:false,
      fundCode:fundCode,
      sValue:e,
      pageIndex:1,
      pageSize:30,
      dataSource: ds.cloneWithRows([]),
      totalDataArr:[],
      loadingFlag:flag,
      handleFlag:true
    })
    let data = {};
    if(fundCode==""&&this.state.businessType==""){
      data = {
        pageIndex:1,
        pageSize:30,
      }
    }else if(fundCode==""){
      data={
        pageIndex:1,
        pageSize:30,
        businessType:this.state.businessType,
      }
    }else if(this.state.businessType == ""){
      data = {
        pageIndex:1,
        pageSize:30,
        fundCode:fundCode
      }
    }else{
      data={
        pageIndex:1,
        pageSize:30,
        businessType:this.state.businessType,
        fundCode:fundCode,
      }
    }
    console.log(data)
    dispatch(getTransformationHistory(data,this.callbackData.bind(this), _this ))
  }
  confirmTypeCallback(e){
    let businessType = e[0];
    let _this = this;
    let flag;
    if(this.state.totalDataArr.length !== 0){
      flag = true;
    }else{
      flag = false;
    }

    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    let { dispatch } = this.props;
    this.setState({
      transactionAll:false,
      businessType:businessType,
      productType:e,
      pageIndex:1,
      pageSize:30,
      dataSource: ds.cloneWithRows([]),
      totalDataArr:[],
      loadingFlag:flag,
      handleFlag:true
    })

    let data = {};
    if(businessType === "" && this.state.fundCode === ""){
        data = {
          pageIndex:1,
          pageSize:30
        }
    }else if(businessType === ""){
      data = {
        pageIndex:1,
        pageSize:30,
        fundCode:this.state.fundCode
      }
    }else if(this.state.fundCode === ""){
      data = {
        pageIndex:1,
        pageSize:30,
        businessType:businessType,
      }
    }else{
      data = {
          pageIndex:1,
          pageSize:30,
          fundCode:this.state.fundCode,
          businessType:businessType,
      }
    }
    dispatch(getTransformationHistory(data,this.callbackData.bind(this), _this))
  }
  onEndReached = (event) => {
    let _this = this;
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading && !this.state.hasMore) {
      return;
    }
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    console.log('reach end', event);

    this.setState({ isLoading: true });

    let { dispatch } = this.props;
    let dataArr = [];
    let totalDataArr = [];

    // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)
    let data = {
        pageIndex:this.state.pageIndex,
        pageSize:this.state.pageSize,
        businessType:this.state.businessType,
        fundCode:this.state.fundCode,
    }
    dispatch(getTransformationHistory(data,this.callbackData.bind(this),_this))

  }
  onOk(e){
    let { dispatch } = this.props;
    this.setState({ sValue:e })
    let data = {
      superFundCode:e[0],
      pageIndex:1,
      pageSize:30,
    }
    if(e[0] === "0000"){
      data.superFundCode = ""
    }
    dispatch(getTransformationHistory(data,this.callbackData.bind(this),this))
  }

  renderFooter(){
    console.log("有无加载",this.state.isLoading)
    if(this.state.isLoading === true){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          正在加载...
        </div>
      )
    }else if(this.state.isLoading === false){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          加载完成            
        </div>
      )
    }else if(this.state.isLoading === 0){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          没有更多数据了
       </div>
      )
    }
  }
  
  
  render() {
    let { superHome, allFundList, } = this.state;
    let data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
    let tempData = [{businessTime:"0000"}];
    tempData = tempData.concat(data);
    let seasons = [
      {
        label: '全部产品',
        value: '',
        key:0
      },
    ];
    superHome && allFundList ?
    (superHome.singleSuperFundViews ? superHome.singleSuperFundViews.map(function(itme,i){
      seasons.push({
        label: itme.superFundName,
        value: itme.superFundCode,
        key:i+1
      })
    }) : null ) : null

    superHome && allFundList ?
    allFundList.map(function(itme,i){
      seasons.push({
        label: itme.fundName,
        value: itme.fundCode,
        key:i+1
      })
    }) : null

    const separator = (sectionID, rowID) => (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 8,
        }}
      />
    );

    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div ><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, textAlign:'center',fontSize:"0.3rem" }}>交易记录</div>
            <div style={{ WebkitFlex:1, textAlign:'right',fontSize:"0.28rem", paddingRight:'0.26rem'}}></div>    
          </div>
          </NavigatorMain>
          <div className='content'>
          {/*
          <div className="chooseBottom">
            <span>全部产品</span><span></span>
          </div>*/}
          <div className="chooseSelects_Wrap" style={{ display: "-webkit-flex" }}>
            <div className={ua.indexOf("amcfmapp")>-1?"chooseSelect_Wrap chooseSelect_Wrap2":"chooseSelect_Wrap"} style={{ position:'relative',background:"#000", WebkitFlex:1 }}>
                <Picker data={productType} cols={1} className="forss" title="交易" value={this.state.productType}  onPickerChange={e => console.log('onPickerChange', e)} onOk={(e)=>{ this.confirmTypeCallback(e) } } >
                  <List.Item></List.Item>
                </Picker>
                <div  className="rightBottomArrow" style={{position:'absolute', right:'0.36rem', top:"50%", zIndex:2}}></div>
            </div>
            <div className={ua.indexOf("amcfmapp")>-1?"chooseSelect_Wrap chooseSelect_Wrap2":"chooseSelect_Wrap"} style={{ position:'relative', background:"#000", WebkitFlex:1 }}>  
                <Picker data={seasons} cols={1} className="forss" title="产品" value={this.state.sValue}  onPickerChange={e => console.log('onPickerChange', e)} onOk={(e)=>{ this.productTypeCallback(e) } } >
                  <List.Item></List.Item>
                </Picker>
                <div  className="rightBottomArrow" style={{position:'absolute',right:'0.36rem', top:"50%", zIndex:2}}></div>
            </div>
          </div>
          
          <div className="ListViewWrap ListHistory_Con">
            <ListView
              ref={el => this.lv = el}
              dataSource={this.state.dataSource}
              renderFooter={()=> this.renderFooter() }
              renderBodyComponent={() => <MyBody />}
              renderRow={(rowData, sectionID, rowID) => {
                objArr = [{createDate: ""}].concat(this.state.totalDataArr);
                return(
                <div>
                  {
                    Util.returnDate(rowData.businessTime,"M") ==  Util.returnDate(objArr[rowID].businessTime,"M")? null :
                    <div style={{paddingLeft:13,paddingRight:13,paddingTop:22,paddingBottom:12,fontSize:"20px"}} >
                      { Util.returnDate(rowData.businessTime,"M") }
                    </div>
                  }
                  <div className="superListJ" onClick={ ()=> this.goTransactionDetail(rowData) } >
                      <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>{ rowData.businessTypeName }</span><span></span></div>
                      <div><span>{ rowData.fundName }</span><span> { getNum(rowData.applicationAmount,rowData.applicationVolume) } </span></div>
                      <div><span>{ rowData.businessStateName  }</span><span> { Util.returnDate(rowData.businessTime) }</span></div>
                  </div>
              </div>
              )
              }

              }
              
  
              style={{
                height: this.state.height,
                overflow: 'auto',
              }}
              pageSize={4}
              onScroll={() => { console.log('scroll'); }}
              scrollRenderAheadDistance={500}
              onEndReached={this.onEndReached}
              onEndReachedThreshold={15}
            />
          </div>
    
          </div>
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords:state.QueryTradeRecords
  }
}

export default connect(mapStateToProps)(TransactionRecordProduct);

function getNum(num1,num2){
  if((num1 === "" || num1 === null || num1 === undefined) && (num2 === "" || num2 === null || num2 === undefined)) {
    return "--";
  }
  if(num1 === "" || num1 === null || num1 === undefined) {
    return num2 + '份';
  }
  if(num2 === "" || num2 === null || num2 === undefined) {
    return num1 + '元';
  }
  if(num1 === 0) {
    return num2 + '份';
  }
  if(num2 === 0) {
    return num1 + '元';
  }
  if(num1 === num2) {
    return num1 + '元';
  }
}





// WEBPACK FOOTER //
// ./src/components/myAssets/queryServices/TransactionRecordProduct.js